import React from 'react';
import { Row, Spacer } from '@amzn/stencil-react-components/layout';
import { PageHeader, PageHeaderList } from '@amzn/stencil-react-components/page';
import { H2 } from '@amzn/stencil-react-components/text';
import { Avatar, AvatarSize } from '@amzn/stencil-react-components/avatar';
import { HOME_PAGE_ROUTE } from 'src/constants';
import SideNavigation from 'src/components/navbar/SideNavigation';
import WorkspaceSelector from 'src/components/workspaces/WorkspaceSelector';
import { useAuthentication } from 'src/components';
import { PageHeaderRouterLink } from 'src/components/shared/page-header-router-link';
import AMAZON_LOGO from '../../../public/assests/images/AMAZON_LOGO.svg';

interface NavigationBarComponentProps {
  viewOnly: boolean;
}

export const NavigationBarComponent = (props: NavigationBarComponentProps) => {
  const { authenticatedUser } = useAuthentication();
  return (
    <PageHeader isFullWidth={true} isFixed={true}>
      {!props.viewOnly && <SideNavigation key="menu" />}
      <Row justifyContent="space-between" width={'100%'} flexWrap={'wrap'}>
        <PageHeaderRouterLink color="neutral0" to={HOME_PAGE_ROUTE} aria-label="Policy Advisor Home">
          <img src={AMAZON_LOGO} alt="Amazon Logo" style={{ height: '2rem' }} />
          <H2 fontWeight="regular" color="white">
            Policy Advisor
          </H2>
        </PageHeaderRouterLink>
        <Row>
          {!props.viewOnly && <WorkspaceSelector key={'workspace-selector'} />}
          <Spacer width={'2rem'} />
          <Avatar username={authenticatedUser?.userName || ''} showUsername={false} size={AvatarSize.Small} />
        </Row>
      </Row>
    </PageHeader>
  );
};
